import App from './App';
import UnauthApp from './UnauthApp';

export default App;

export { UnauthApp };
